import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './met-source-beneficiary.reducer';
import { IMetSourceBeneficiary } from 'app/shared/model/met-source-beneficiary.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetSourceBeneficiary = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const metBeneficiaryList = useAppSelector(state => state.metSourceBeneficiary.entities);
  const loading = useAppSelector(state => state.metSourceBeneficiary.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="met-source-beneficiary-heading" data-cy="MetSourceBeneficiaryHeading">
        <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.home.title">Source Beneficiary</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.home.createLabel">Create new Source Beneficiary</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {metBeneficiaryList && metBeneficiaryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.code">Code</Translate>
                </th>

                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {metBeneficiaryList.map((metSourceBeneficiary, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${metSourceBeneficiary.id}`} color="link" size="sm">
                      {metSourceBeneficiary.id}
                    </Button>
                  </td>
                  <td>{metSourceBeneficiary.code}</td>
                  <td>{metSourceBeneficiary.name}</td>
                  <td>{metSourceBeneficiary.nameAr}</td>
                  <td>{metSourceBeneficiary.nameEn}</td>

                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${metSourceBeneficiary.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${metSourceBeneficiary.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metSourceBeneficiary.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metSourceBeneficiary.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.metSourceBeneficiary.home.notFound">No Source Beneficiary found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MetSourceBeneficiary;
